<template>
  <div
    v-for="item in columns"
    :key="item[columnsFieldNames.value]"
    :class="selectedColumns.includes(item) ? 'text-theme bg-theme2' : ' text-default bg-white'"
  >
    <div class="flex items-center border-b" :style="{ marginLeft: `${zIndex * 15}px` }">
      <div class="flex-1" @click="onSelect(item)">
        <slot name="item" v-bind="item">
          <div class="h-50 text-16 flex items-center">
            {{ item[columnsFieldNames.text] }}
          </div>
        </slot>
      </div>
      <div
        v-if="item[columnsFieldNames.children]?.length > 0"
        class="w-42 h-30 flex justify-center items-center border-l"
        @click="item._expand = !item._expand"
      >
        <van-icon :name="item._expand ? 'arrow-down' : 'arrow'" color="#999" size="20" />
      </div>
    </div>
    <PickerItem
      v-if="item[columnsFieldNames.children]?.length > 0 && item._expand"
      :z-index="zIndex + 1"
      :columns="item[columnsFieldNames.children]"
      :selected-columns="selectedColumns"
      :columns-field-names="columnsFieldNames"
      @select="onSelect"
    >
      <template v-for="(index, name) in $slots" #[name]="slotProps">
        <slot :name="name" v-bind="slotProps" />
      </template>
    </PickerItem>
  </div>
</template>
<script setup>
defineProps({
  selectedColumns: Array,
  columns: Array,
  columnsFieldNames: Object,
  zIndex: {
    default: 1
  }
});

const emit = defineEmits(["select"]);

const onSelect = column => {
  emit("select", column);
};
</script>
